export default "__VITE_ASSET__1f1fE39$__"